import { LogEntryStatusItemCombinedProps } from './types';

const usePresenter = (props: LogEntryStatusItemCombinedProps): LogEntryStatusItemCombinedProps => {
  return props;
};

export default usePresenter;
